// src/utils/artworkAccess.js
import { supabase } from "../lib/supabaseClient";

/**
 * Log une vue "view" de fiche oeuvre (best-effort).
 * @param {string} artworkId uuid
 * @param {object} opts
 */
export async function logArtworkAccess({ artworkId, action = "view", source = "artwork_detail", note = null }) {
  if (!artworkId) return { ok: false, error: new Error("Missing artworkId") };

  const { error } = await supabase.rpc("log_artwork_access", {
    p_artwork_id: artworkId,
    p_action: action,
    p_source: source,
    p_note: note,
  });

  if (error) return { ok: false, error };
  return { ok: true, error: null };
}

/**
 * Transforme les lignes de v_artwork_access_history en items UI "tiers".
 */
export function mapThirdPartyAccessRows(accessRows = []) {
  return (accessRows || [])
    .filter((r) => r && r.viewer_role !== "client") // exclure le propriétaire
    .map((r) => ({
      kind: "view",
      occurred_at: r.accessed_at,
      title: r.action === "view" ? "Consultation" : "Modification",
      name: r.viewer_name || "Utilisateur",
      role: r.viewer_role,
      action: r.action,
      source: r.source,
      note: r.note,
    }));
}

/**
 * Charge l'historique d'accès (tiers) depuis la vue.
 */
export async function fetchThirdPartyArtworkAccess({ artworkId, limit = 200 }) {
  if (!artworkId) return { items: [], error: null };

  const { data, error } = await supabase
    .from("v_artwork_access_history")
    .select("accessed_at, viewer_name, viewer_role, action, source, note")
    .eq("artwork_id", artworkId)
    .order("accessed_at", { ascending: false })
    .limit(limit);

  if (error) return { items: [], error };
  return { items: mapThirdPartyAccessRows(data || []), error: null };
}
